import React, { useState, useEffect } from 'react';
import blog1 from '../images/blog1.jpg';
import blog2 from '../images/medrac.jpg';
import axiosInstance from '../utils/axiosInstance';
import './blog.css';

function Blog() {
  const [posts, setPosts] = useState([]);
  const blogImages = [blog2, blog1];
  const API_URL = process.env.REACT_APP_ENV;

  useEffect(() => {
    axiosInstance.get(`${API_URL}/blog`)
      .then(res => setPosts(res.data))
      .catch(err => console.error("Failed to fetch blog posts:", err));
  }, []);

  if (!posts.length) return <p className="loading">Loading...</p>;

  return (
    <main className="blog-container">
      {posts.map((post, idx) => (
        <article key={post.id} className="single-post">
          <img src={blogImages[idx]} alt={post.title} className="post-image" />
          <h1 className="blog-title">{post.title}</h1>
          <p className="blog-date">{new Date(post.date).toDateString()}</p>
          <section
            className="blog-post"
            dangerouslySetInnerHTML={{ __html: post.sections }}
          />
        </article>
      ))}
    </main>
  );
}

export default Blog;
